module.exports = __webpack_public_path__ + "img/book-05.e5f2ea31.png";